// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #000000;
    /*background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../../../public/img/TicketsBackground\\ -DieterK.jpg');*/
    background-repeat: no-repeat;
    background-size: 100vw 100vh;
    background-attachment: fixed;
}

#Nav {
    position: sticky;
    top: 0;
    display: flex;
    overflow: hidden;
    justify-content: center;
    height: 100px;
}

@media screen and (min-width: 768px) {
    #trapezoid {
        box-sizing: content-box;
        height: 0;
        border: 80px solid rgba(0, 0, 0, 0);
        border-top: 0 solid;
        border-bottom: 100px solid rgba(1, 1, 1, .4);
        border-radius: 20px 20px 0 0;
        font: normal 100%/normal Arial, Helvetica, sans-serif;
        color: rgba(0, 0, 0, 0.7);
        text-overflow: clip;
        transform: rotateX(180deg);
        margin-top: -53px;
        width: 700px;
        position: relative;
        transition: all 0.7s ease;
        padding-left: 10%;
        padding-top: 4%;
    }

    #trapezoid a {
        transform: rotateX(180deg);
    }

    .navcontainer {
        display: flex;
        flex-wrap: inherit;
        align-items: center;
        justify-content: space-between;
    }

    .navbar2 {
        position: sticky;
        top: 0;
        display: flex;
        overflow: hidden;
        justify-content: center;
        height: 100px;
    }

    .navbar2 a {
        float: left;
        font-size: 16px;
        color: white;
        text-align: center;
        padding: 14px 25px;
        text-decoration: none;
        text-transform: uppercase;
        letter-spacing: 4px;
        transition: all 0.5s ease;
    }

    .navbar2 a:hover {
        background: #8CA6DB;
        color: black;
        border-radius: 5px;
    }
}





`, "",{"version":3,"sources":["webpack://./src/Body/Body.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yIAAyI;IACzI,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI;QAGI,uBAAuB;QACvB,SAAS;QACT,mCAAmC;QACnC,mBAAmB;QACnB,4CAA4C;QAE5C,4BAA4B;QAC5B,qDAAqD;QACrD,yBAAyB;QAEzB,mBAAmB;QAEnB,0BAA0B;QAC1B,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QAEI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;QAChB,MAAM;QACN,aAAa;QACb,gBAAgB;QAChB,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,qBAAqB;QACrB,yBAAyB;QACzB,mBAAmB;QACnB,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;IACtB;AACJ","sourcesContent":["body {\r\n    background-color: #000000;\r\n    /*background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../../../public/img/TicketsBackground\\ -DieterK.jpg');*/\r\n    background-repeat: no-repeat;\r\n    background-size: 100vw 100vh;\r\n    background-attachment: fixed;\r\n}\r\n\r\n#Nav {\r\n    position: sticky;\r\n    top: 0;\r\n    display: flex;\r\n    overflow: hidden;\r\n    justify-content: center;\r\n    height: 100px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n    #trapezoid {\r\n        -webkit-box-sizing: content-box;\r\n        -moz-box-sizing: content-box;\r\n        box-sizing: content-box;\r\n        height: 0;\r\n        border: 80px solid rgba(0, 0, 0, 0);\r\n        border-top: 0 solid;\r\n        border-bottom: 100px solid rgba(1, 1, 1, .4);\r\n        -webkit-border-radius: 20px 20px 0 0;\r\n        border-radius: 20px 20px 0 0;\r\n        font: normal 100%/normal Arial, Helvetica, sans-serif;\r\n        color: rgba(0, 0, 0, 0.7);\r\n        -o-text-overflow: clip;\r\n        text-overflow: clip;\r\n        -webkit-transform: rotateX(180deg);\r\n        transform: rotateX(180deg);\r\n        margin-top: -53px;\r\n        width: 700px;\r\n        position: relative;\r\n        transition: all 0.7s ease;\r\n        padding-left: 10%;\r\n        padding-top: 4%;\r\n    }\r\n\r\n    #trapezoid a {\r\n        -webkit-transform: rotateX(180deg);\r\n        transform: rotateX(180deg);\r\n    }\r\n\r\n    .navcontainer {\r\n        display: flex;\r\n        flex-wrap: inherit;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .navbar2 {\r\n        position: sticky;\r\n        top: 0;\r\n        display: flex;\r\n        overflow: hidden;\r\n        justify-content: center;\r\n        height: 100px;\r\n    }\r\n\r\n    .navbar2 a {\r\n        float: left;\r\n        font-size: 16px;\r\n        color: white;\r\n        text-align: center;\r\n        padding: 14px 25px;\r\n        text-decoration: none;\r\n        text-transform: uppercase;\r\n        letter-spacing: 4px;\r\n        transition: all 0.5s ease;\r\n    }\r\n\r\n    .navbar2 a:hover {\r\n        background: #8CA6DB;\r\n        color: black;\r\n        border-radius: 5px;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
